import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function toMultilineText(text: string, separator = " – ") {
    return text.split(separator).join("\n");
}

export const formatNumber = (num: number): string => {
    return num < 10 ? `0${num}` : `${num}`;
};

const EXTERNAL_HREF_PREFIXES = ["http", "#", "mailto:", "tel:"];

export function isExternalHref(href: string) {
    return EXTERNAL_HREF_PREFIXES.some((prefix) => href.startsWith(prefix));
}

export function localizePath(href: string, lang: string) {
    if (isExternalHref(href)) {
        return href;
    }

    if (lang === "de") {
        return href;
    }

    return `/${lang}${href === "/" ? "" : href}`;
}
